import GolfIcon from "../../assets/offers/golf.png";
import BeachIcon from "../../assets/offers/beach.png";
import SkiIcon from "../../assets/offers/ski.png";
import CulinaryIcon from "../../assets/offers/culinary.png";
import MusicIcon from "../../assets/offers/music.png";
import SpaIcon from "../../assets/offers/spa.png";
import ArtsIcon from "../../assets/offers/arts.png";



const passions = {
  golf: {
    chipColor: "#FF8D6B",
    chip: "GOLFERS PARADISE",
    icon: GolfIcon,
    buttonLink: "See Offer Details",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/ahnrz-golf-course-9711?wid=1600&fit=constrain",
    passionDescription:
      "Book your golf vacation and earn up to a $100 credit per night at one of our participating resorts on stays of three nights or more.",
  },
  beach: {
    chipColor: "#FF8D6B",
    chip: "BEACHSIDE GETAWAY",
    icon: BeachIcon,
    buttonLink: "See Offer Details",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/rz-sjudo-dr106833-40282?wid=1600&fit=constrain",
    passionDescription:
      "Book your beach vacation and earn up to a $100 credit per night at one of our participating resorts on stays of three nights or more.",
  },
  ski: {
    chipColor: "#FF8D6B",
    chip: "WINTER WONDERLAND",
    icon: SkiIcon,
    buttonLink: "See Offer Details",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/GettyImages-637078978?wid=1600&fit=constrain",
    passionDescription:
      "Book your ski vacation and earn up to a $100 credit per night at one of our participating resorts on stays of three nights or more.",
  },
  culinary: {
    chipColor: "#FF8D6B",
    chip: "CULINARY JOURNEY",
    icon: CulinaryIcon,
    buttonLink: "See Offer Details",
    image:
      "https://www.marriott.com/content/dam/marriott-digital/bonvoy/global/en_us/photo/unlimited/assets/bonvoy-gettyimages-1424166516-20001.jpg",
    passionDescription:
      "Book your culinary vacation and earn up to a $100 credit per night at one of our participating resorts on stays of three nights or more.",
  },
  music: {
    chipColor: "#FF8D6B",
    chip: "MUSIC",
    icon: MusicIcon,
    buttonLink: "See Offer Details",
    image:
      "https://cache.marriott.com/is/image/marriotts7prod/eb-madeb-market-at-edition-41996?wid=516&fit=constrain",
    passionDescription:
      "Book your music vacation and earn up to a $100 credit per night at one of our participating resorts on stays of three nights or more.",
  },
};

// Brand logo URLs for MoreFiltersModal
const brandLogos = {
  // Luxury Brands
  EB: {
    id: 'EB',
    name: 'EDITION',
    logo: 'https://images.harmony.epsilon.com/ContentHandler/images/53f8cdc5-f8c9-4f2b-a7dd-75b24dd12773/Images_Logos/EB_BRAND_header.png'
  },
  RZ: {
    id: 'RZ',
    name: 'The Ritz-Carlton',
    logo: 'https://images.harmony.epsilon.com/ContentHandler/images/53f8cdc5-f8c9-4f2b-a7dd-75b24dd12773/Images_Logos/RC_BRAND_header.png'
  },
  LC: {
    id: 'LC',
    name: 'The Luxury Collection',
    logo: 'https://images.harmony.epsilon.com/ContentHandler/images/53f8cdc5-f8c9-4f2b-a7dd-75b24dd12773/Images_Logos/LC_BRAND_header.png'
  },
  XR: {
    id: 'XR',
    name: 'St. Regis',
    logo: 'https://images.harmony.epsilon.com/ContentHandler/images/53f8cdc5-f8c9-4f2b-a7dd-75b24dd12773/Images_Logos/XR_BRAND_header.png'
  },
  WH: {
    id: 'WH',
    name: 'W Hotels',
    logo: 'https://images.harmony.epsilon.com/ContentHandler/images/53f8cdc5-f8c9-4f2b-a7dd-75b24dd12773/Images_Logos/WH_BRAND_header.png'
  },
  JW: {
    id: 'JW',
    name: 'JW Marriott',
    logo: 'https://images.harmony.epsilon.com/ContentHandler/images/53f8cdc5-f8c9-4f2b-a7dd-75b24dd12773/Images_Logos/JW_BRAND_header.png'
  },
  // Premium Brands
  MC: {
    id: 'MC',
    name: 'Marriott Hotels & Resorts',
    logo: 'https://media.4at5.net/email_domains/mar/315770/images/770x390_logos_white/logo_marriott_final_white.png'
  },
  SI: {
    id: 'SI',
    name: 'Sheraton',
    logo: 'https://media.4at5.net/email_domains/mar/315770/images/770x390_logos_black/logo_sheraton_final.png'
  },
  DE: {
    id: 'DE',
    name: 'Delta Hotels and Resorts',
    logo: 'https://media.4at5.net/email_domains/mar/315770/images/770x390_logos_white/logo_delta_final_white.png'
  },
  WI: {
    id: 'WI',
    name: 'Westin',
    logo: 'https://media.4at5.net/email_domains/mar/315770/images/770x390_logos_white/logo_westin_logo_white.png'
  },
  // Additional brands
  BR: {
    id: 'BR',
    name: 'Renaissance Hotels',
    logo: 'https://media.4at5.net/email_domains/mar/315770/images/770x390_logos_black/logo_renaissance_final.png'
  },
  AK: {
    id: 'AK',
    name: 'Autograph Collection',
    logo: 'https://media.4at5.net/email_domains/mar/315770/images/770x390_logos_white/logo_autograph_final_white.png'
  },
  TX: {
    id: 'TX',
    name: 'Tribute',
    logo: 'https://media.4at5.net/email_domains/mar/315770/images/770x390_logos_black/logo_tribute_final.png'
  }
};

// Structured brand data for MoreFiltersModal
const luxuryBrands = [
  { id: "edition", name: "EDITION", icon: brandLogos.EB.logo },
  { id: "ritz-carlton", name: "The Ritz-Carlton", icon: brandLogos.RZ.logo },
  { id: "luxury-collection", name: "The Luxury Collection", icon: brandLogos.LC.logo },
  { id: "st-regis", name: "St. Regis", icon: brandLogos.XR.logo },
  { id: "w-hotels", name: "W Hotels", icon: brandLogos.WH.logo },
  { id: "jw-marriott", name: "JW Marriott", icon: brandLogos.JW.logo },
  { id: "autograph", name: "Autograph Collection", icon: brandLogos.AK.logo },
];

const premiumBrands = [
  { id: "marriott", name: "Marriott Hotels", icon: brandLogos.MC.logo },
  { id: "sheraton", name: "Sheraton", icon: brandLogos.SI.logo },
  { id: "delta", name: "Delta Hotels", icon: brandLogos.DE.logo },
  { id: "westin", name: "Westin", icon: brandLogos.WI.logo },
  { id: "renaissance", name: "Renaissance Hotels", icon: brandLogos.BR.logo },
  { id: "tribute", name: "Tribute", icon: brandLogos.TX.logo },
];

const passionFilters = [
  { id: "golf", name: "Golf", icon: GolfIcon },
  { id: "spa", name: "Spa", icon: SpaIcon },
  { id: "winter-sports", name: "Winter Sports", icon: SkiIcon },
  { id: "beach", name: "Beach", icon: BeachIcon },
  { id: "culinary", name: "Culinary", icon: CulinaryIcon },
  { id: "live-music", name: "Live Music", icon: MusicIcon },
  { id: "arts-culture", name: "Arts & Culture", icon: ArtsIcon },
];

const citiesIdsMap = {
  "Agra": "ChIJ2UEvfIUNdDkRQjtSqTjvSng",
  "AGR": "ChIJ2UEvfIUNdDkRQjtSqTjvSng",

  "Amman": "ChIJr4F5XbhfGxUR6GXc-MAwHGM",

  "Amsterdam": "ChIJVXealLU_xkcRja_At0z9AGY",
  "AMS": "ChIJVXealLU_xkcRja_At0z9AGY",

  "Athens": "ChIJ8UNwBh-9oRQR3Y1mdkU1Nic",
  "ATH": "ChIJ8UNwBh-9oRQR3Y1mdkU1Nic",

  "Atlanta": "ChIJKThVhKbZNE0R-sa4nOv5haE",

  "Bangkok": "ChIJ82ENKDJgHTERIEjiXbIAAQE",
  "Amphoe Phra Nakhon": "ChIJ82ENKDJgHTERIEjiXbIAAQE",

  "Barcelona": "ChIJ5TCOcRaYpBIRCmZHTz37sEQ",
  "BCN": "ChIJ5TCOcRaYpBIRCmZHTz37sEQ",

  "Berlin": "ChIJAVkDPzdOqEcRcDteW0YgIQQ",
  "BER": "ChIJAVkDPzdOqEcRcDteW0YgIQQ",

  "Boston": "ChIJGzE9DS1l44kRoOhiASS_fHg",
  "BOS": "ChIJGzE9DS1l44kRoOhiASS_fHg",

  "Brussels": "ChIJZ2jHc-2kw0cRpwJzeGY6i8E",
  "An Bhruiseil": "ChIJZ2jHc-2kw0cRpwJzeGY6i8E",

  "Budapest": "ChIJyc_U0TTDQUcRYBEeDCnEAAQ",
  "BUD": "ChIJyc_U0TTDQUcRYBEeDCnEAAQ",

  "Cancun": "ChIJ21P2rgUrTI8Ris1fYjy3Ms4",
  "CUN": "ChIJ21P2rgUrTI8Ris1fYjy3Ms4",

  "Cape Town": "ChIJ1-4miA9QzB0Rh6ooKPzhf2g",
  "Altepetl In Cabo": "ChIJ1-4miA9QzB0Rh6ooKPzhf2g",

  "Chennai": "ChIJYTN9T-plUjoRM9RjaAunYW4",
  "Cenaj": "ChIJYTN9T-plUjoRM9RjaAunYW4",

  "Chiba": "ChIJ38TuyMGaImAR5pEdrNwLnGg",

  "Chicago": "ChIJ7cv00DwsDogRAMDACa2m4K8",
  "CHI": "ChIJ7cv00DwsDogRAMDACa2m4K8",

  "Colombo": "ChIJA3B6D9FT4joRjYPTMk0uCzI",
  "CMB": "ChIJA3B6D9FT4joRjYPTMk0uCzI",

  "Copenhagen": "ChIJIz2AXDxTUkYRuGeU5t1-3QQ",
  "CPH": "ChIJIz2AXDxTUkYRuGeU5t1-3QQ",

  "Dallas": "ChIJS5dFe_cZTIYRj2dH9qSb7Lk",
  "Dalas": "ChIJS5dFe_cZTIYRj2dH9qSb7Lk",

  "Dammam": "ChIJAzRrJzIdNj4RdlZeeuwB2e8",
  "Ad Dammam": "ChIJAzRrJzIdNj4RdlZeeuwB2e8",

  "Delhi": "ChIJLbZ-NFv9DDkRQJY4FbcFcgM",
  "DEL": "ChIJLbZ-NFv9DDkRQJY4FbcFcgM",

  "Denpasar": "ChIJ24BeDptA0i0RSje5zOg0c-I",
  "DPS": "ChIJ24BeDptA0i0RSje5zOg0c-I",

  "Dubai": "ChIJRcbZaklDXz4RYlEphFBu5r0",
  "DXB": "ChIJRcbZaklDXz4RYlEphFBu5r0",

  "Dublin": "ChIJL6wn6oAOZ0gRoHExl6nHAAo",
  "Baile Atha Cliath": "ChIJL6wn6oAOZ0gRoHExl6nHAAo",

  "Durban": "ChIJt2G8AQCq9x4RgW6qxEZVp8w",
  "DUR": "ChIJt2G8AQCq9x4RgW6qxEZVp8w",

  "Edinburgh": "ChIJIyaYpQC4h0gRJxfnfHsU8mQ",

  "Florence": "ChIJrdbSgKZWKhMRAyrH7xd51ZM",
  "FLR": "ChIJrdbSgKZWKhMRAyrH7xd51ZM",

  "Guangzhou": "ChIJxytco5X4AjQRFeTqrXXgWQ4",
  "CAN": "ChIJxytco5X4AjQRFeTqrXXgWQ4",

  "Hong Kong": "ChIJD5gyo-3iAzQRfMnq27qzivA",
  "Chon'nk Kon'nk": "ChIJD5gyo-3iAzQRfMnq27qzivA",

  "Honolulu": "ChIJTUbDjDsYAHwRbJen81_1KEs",
  "Anorourou": "ChIJTUbDjDsYAHwRbJen81_1KEs",

  "Houston": "ChIJAYWNSLS4QIYROwVl894CDco",

  "Istanbul": "ChIJawhoAASnyhQR0LABvJj-zOE",
  "Bizanc": "ChIJawhoAASnyhQR0LABvJj-zOE",

  "Jaipur": "ChIJgeJXTN9KbDkRCS7yDDrG4Qw",
  "Caypur": "ChIJgeJXTN9KbDkRCS7yDDrG4Qw",

  "Jerusalem": "ChIJS_zBNNbXAhURy-FuRT5ib9k",
  "Adonai-jireh": "ChIJS_zBNNbXAhURy-FuRT5ib9k",

  "Johannesburg": "ChIJUWpA8GgMlR4RQUDTsdnJiiM",
  "EGoli": "ChIJUWpA8GgMlR4RQUDTsdnJiiM",

  "Krabi": "ChIJCZN_LXmNUTARkEw2LLwjAgE",
  "Amphoe Muang Krabi": "ChIJCZN_LXmNUTARkEw2LLwjAgE",

  "Kuala Lumpur": "ChIJ0-cIvSo2zDERmWzYQPUfLiM",
  "Gizlungzpoh": "ChIJ0-cIvSo2zDERmWzYQPUfLiM",

  "Kyoto": "ChIJ8cM8zdaoAWARPR27azYdlsA",
  "Kejuots": "ChIJ8cM8zdaoAWARPR27azYdlsA",

  "Lagos": "ChIJjU0jUEkwGw0RV_waR6OqEFQ",
  "Eko": "ChIJjU0jUEkwGw0RV_waR6OqEFQ",

  "Las Vegas": "ChIJ0X31pIK3voARo3mz1ebVzDo",
  "Campi": "ChIJ0X31pIK3voARo3mz1ebVzDo",

  "Lima": "ChIJxz7uGfbFBZERSi5FzLlsIBQ",
  "LIM": "ChIJxz7uGfbFBZERSi5FzLlsIBQ",

  "Lisbon": "ChIJO_PkYRozGQ0R0DaQ5L3rAAQ",
  "Felicitas Julia": "ChIJO_PkYRozGQ0R0DaQ5L3rAAQ",

  "London": "ChIJdd4hrwug2EcRmSrV3Vo6llI",
  "ILondon": "ChIJdd4hrwug2EcRmSrV3Vo6llI",

  "Los Angeles": "ChIJE9on3F3HwoAR9AhGJW_fL-I",
  "Angelopolis": "ChIJE9on3F3HwoAR9AhGJW_fL-I",

  "Macau": "ChIJ88g14uB6ATQR9qyFtCzje8Y",
  "Aomen": "ChIJ88g14uB6ATQR9qyFtCzje8Y",

  "Madrid": "ChIJgTwKgJcpQg0RaSKMYcHeNsQ",
  "La Villa y Corte de Madrid": "ChIJgTwKgJcpQg0RaSKMYcHeNsQ",

  "Manila": "ChIJi8MeVwPKlzMRH8FpEHXV0Wk",
  "City of Manila": "ChIJi8MeVwPKlzMRH8FpEHXV0Wk",

  "Marrakesh": "ChIJUZ4Xlo3urw0RuK2HT1O2UFk",
  "Marakes": "ChIJUZ4Xlo3urw0RuK2HT1O2UFk",

  "Mecca": "ChIJdYeB7UwbwhURzslwz2kkq5g",
  "A Meca": "ChIJdYeB7UwbwhURzslwz2kkq5g",

  "Mexico City": "ChIJB3UJ2yYAzoURQeheJnYQBlQ",
  "Cdmx": "ChIJB3UJ2yYAzoURQeheJnYQBlQ",

  "Miami": "ChIJEcHIDqKw2YgRZU-t3XHylv8",
  "MIO": "ChIJEcHIDqKw2YgRZU-t3XHylv8",

  "Milan": "ChIJ53USP0nBhkcRjQ50xhPN_zw",
  "Lungsod ng Milano": "ChIJ53USP0nBhkcRjQ50xhPN_zw",

  "Moscow": "ChIJybDUc_xKtUYRTM9XV8zWRD0",
  "MOW": "ChIJybDUc_xKtUYRTM9XV8zWRD0",

  "Munich": "ChIJ2V-Mo_l1nkcRfZixfUq4DAE",
  "Lungsod ng Muenchen": "ChIJ2V-Mo_l1nkcRfZixfUq4DAE",

  "Mugla": "ChIJv_ZssQlyvxQRwcF6HNYppfs",
  "Mentese": "ChIJv_ZssQlyvxQRwcF6HNYppfs",

  "Naples": "ChIJrdfCc5vh2ogRqpos1xhTP2c",
  "NAP": "ChIJrdfCc5vh2ogRqpos1xhTP2c",

  "New York City": "ChIJOwg_06VPwokRYv534QaPC8g",
  "Aebura": "ChIJOwg_06VPwokRYv534QaPC8g",

  "Nice": "ChIJMS2FahDQzRIRcJqX_aUZCAQ",
  "NCE": "ChIJMS2FahDQzRIRcJqX_aUZCAQ",

  "Orlando": "ChIJd7zN_thz54gRnr-lPAaywwo",
  "ORL": "ChIJd7zN_thz54gRnr-lPAaywwo",

  "Osaka": "ChIJ4eIGNFXmAGAR5y9q5G7BW8U",
  "OSA": "ChIJ4eIGNFXmAGAR5y9q5G7BW8U",

  "Palma": "ChIJV8caxlmSlxIRxljQwwZUDcQ",
  "Ciutat de Mallorca": "ChIJV8caxlmSlxIRxljQwwZUDcQ",

  "Paris": "ChIJD7fiBh9u5kcRYJSMaMOCCwQ",
  "Baariis": "ChIJD7fiBh9u5kcRYJSMaMOCCwQ",

  "Phuket": "ChIJT1JixOIxUDARIbo9BoWayuk",
  "Amphoe Muang Phuket": "ChIJT1JixOIxUDARIbo9BoWayuk",

  "Prague": "ChIJi3lwCZyTC0cRkEAWZg-vAAQ",
  "PRG": "ChIJi3lwCZyTC0cRkEAWZg-vAAQ",

  "Pune": "ChIJARFGZy6_wjsRQ-Oenb9DjYI",
  "PNQ": "ChIJARFGZy6_wjsRQ-Oenb9DjYI",

  "Quito": "ChIJn3xCAkCa1ZERclXvWOGRuUQ",
  "Kita": "ChIJn3xCAkCa1ZERclXvWOGRuUQ",

  "Rome": "ChIJw0rXGxGKJRMRAIE4sppPCQM",
  "An Roimh": "ChIJw0rXGxGKJRMRAIE4sppPCQM",

  "Saint Petersburg": "ChIJnW9Kx4w3lkYR5MklR1rKR_o",
  "Agia Petroupole": "ChIJnW9Kx4w3lkYR5MklR1rKR_o",

  "San Francisco": "ChIJIQBpAG2ahYAR_6128GcTUEo",
  "Franciscopolis": "ChIJIQBpAG2ahYAR_6128GcTUEo",

  "Singapore": "ChIJdZOLiiMR2jERxPWrUs9peIg",
  "SIN": "ChIJdZOLiiMR2jERxPWrUs9peIg",

  "Stockholm": "ChIJywtkGTF2X0YRZnedZ9MnDag",
  "Estocolm": "ChIJywtkGTF2X0YRZnedZ9MnDag",

  "Sydney": "ChIJP3Sa8ziYEmsRUKgyFmh9AQM",
  "SYD": "ChIJP3Sa8ziYEmsRUKgyFmh9AQM",

  "Sao Paulo": "ChIJ0WGkg4FEzpQRrlsz_whLqZs",
  "SAO": "ChIJ0WGkg4FEzpQRrlsz_whLqZs",

  "Tehran": "ChIJ2dzzH0kAjj8RvCRwVnxps_A",
  "THR": "ChIJ2dzzH0kAjj8RvCRwVnxps_A",

  "Tel Aviv": "ChIJH3w7GaZMHRURkD-WwKJy-8E",
  "Lungsod ng Tel Aviv-Yafo": "ChIJH3w7GaZMHRURkD-WwKJy-8E",

  "Tokyo": "ChIJ51cu8IcbXWARiRtXIothAS4",
  "Edo": "ChIJ51cu8IcbXWARiRtXIothAS4",

  "Toronto": "ChIJpTvG15DL1IkRd8S0KlBVNTI",
  "Taronta": "ChIJpTvG15DL1IkRd8S0KlBVNTI",

  "Vancouver": 'ChIJs0-pQ_FzhlQRi_OBm-qWkbs',
  "Ban'kouber": "ChIJs0-pQ_FzhlQRi_OBm-qWkbs",

  "Venice": "ChIJiT3W8dqxfkcRLxCSvfDGo3s",
  "Benatky": "ChIJiT3W8dqxfkcRLxCSvfDGo3s",

  "Washington": "ChIJW-T2Wt7Gt4kRKl2I1CJFUsI",
  "District of Columbia": "ChIJW-T2Wt7Gt4kRKl2I1CJFUsI",

  "Zurich": "ChIJGaK-SZcLkEcRA9wf5_GNbuY",
  "Cirihe": "ChIJGaK-SZcLkEcRA9wf5_GNbuY"
};


export { passions, luxuryBrands, premiumBrands, passionFilters, citiesIdsMap };